import EmbeddedVideo from "../components/EmbeddedVideo";
import Title from "../components/Title";
import Paragraph from "../components/Paragraph";

function Music(){
    return(
        <>
            <Title text="Music" fontSize={5}/>
            <Paragraph fontSize={2.2} maxWidth={80}>
                I've been into music since I was 10, starting with live stage performances as a
                vocalist. Around 17, I picked up guitar and quickly became hooked; it's now a
                core creative outlet for me.
            </Paragraph>
            <Paragraph fontSize={2.2} maxWidth={80}>
                These days, I focus on covers and simple arrangements I can share online. I am,
                however, in the process of learning how to utilise digital composition to my advantage.
                I've released two covers so far, with more in the works.
            </Paragraph>
            <Paragraph fontSize={2.2} maxWidth={80}>
                Here's a preview of what I've been working on:
            </Paragraph>
            <EmbeddedVideo/>
        </>
    )
}

export default Music;